// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MiniRound-root-592d{background-color:var(--mini-background-color)}`, "",{"version":3,"sources":["webpack://./src/page/MiniRound/MiniRound.module.scss"],"names":[],"mappings":"AAAA,qBACE,6CAAA","sourcesContent":[".root {\n  background-color: var(--mini-background-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `MiniRound-root-592d`
};
module.exports = ___CSS_LOADER_EXPORT___;
